import Button from '@mui/material/Button'
import React from 'react'
import { getButtonTestId } from './getButtonTestId'

/** @notExported */
interface CaleoGreenButtonProps {
  /** Action to perform when the button is clicked. */
  clickAction: (e: React.MouseEvent<HTMLButtonElement>) => void
  /** Whether the button is valid. */
  valid: boolean
  /** Label for the button. */
  label: React.ReactNode
  /** Test id of the button. */
  testId?: string
}

/**
 * Caleo green button.
 *
 * @returns Caleo green button component.
 * @notExported
 * @category Buttons
 */
const CaleoGreenButton: React.FC<CaleoGreenButtonProps> = ({ clickAction, valid, label, testId }) => {
  const resolvedTestId = getButtonTestId({ fallback: 'button-green', label, testId })

  return (
    <Button
      id="search"
      data-testid={resolvedTestId}
      type="button"
      variant="contained"
      disabled={!valid}
      onClick={(e: React.MouseEvent<HTMLButtonElement>) => clickAction(e)}
      color="success"
    >
      {label}
    </Button>
  )
}

export default CaleoGreenButton
